import React from 'react';
import { arrayOf, shape, array, string, bool, oneOf, node, func } from 'prop-types';
import { useMediaQuery } from '@material-ui/core';
import TableDesktop from './desktop/Table';
import TableMobile from './mobile/TableMobile';
function Table(props) {
  const isDesktop = useMediaQuery('(min-width: 768px)');
  return isDesktop ? /*#__PURE__*/React.createElement(TableDesktop, props) : /*#__PURE__*/React.createElement(TableMobile, props);
}
Table.defaultProps = {
  defaultSortDirection: 'asc',
  dividers: true,
  onSelectionChange: function () {},
  selectable: false,
  zebra: false
};
Table.propTypes = {
  /** Array of column definitions used to draw the table. */
  columns: arrayOf(shape({
    align: oneOf(['center', 'left', 'right', 'justify']),
    className: string,
    field: string,
    header: node,
    id: string.isRequired,
    mobileProps: shape({
      visible: bool
    }),
    render: func,
    sortable: bool
  })).isRequired,
  /** An array with the items that will be shown in the table. */
  data: array.isRequired,
  /** The field that should be used to sort the table initially. */
  defaultSortBy: string,
  /** The direction the table should be sorted initially. */
  defaultSortDirection: oneOf(['asc', 'desc']),
  /** If the table should have a border between each row. */
  dividers: bool,
  /** Callback that is called every time the selection changes in the table. */
  onSelectionChange: func,
  /** Function used to sort the table with a custom algorithm.  */
  onSort: func,
  /** The field that should be used to generate the React key of each row. */
  rowKey: string.isRequired,
  /** If the table should have checkboxes to select the rows. */
  selectable: bool,
  /** If the table should have zebra stripes. */
  zebra: bool
};
export default Table;